<label class="flex mb-4 items-center cursor-pointer">
  <input
    class="mr-3 cursor-pointer"
    type="radio"
    [name]="name"
    [checked]="modelValue === value"
    (change)="onRadioChange()"
    [disabled]="!enabled"
  />
  <span [class]="'flex items-center ' + labelClass">
    <ng-content></ng-content>
  </span>
</label>
